<!--
  ~ Copyright (c) Akveo 2019. All Rights Reserved.
  ~ Licensed under the Single Application / Multi Application License.
  ~ See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
  -->

  <div class="header-container">
    <div class="logo-container">
      <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
        <nb-icon icon="menu-2-outline"></nb-icon>
      </a>
      <img src="../../../../assets/images/solapur.png" width="80px;" height="80px;" >
      <span>ADMIN</span>
      
    </div>
    <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
      <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
    </nb-select> -->
  </div>
  
    <!-- <p (click)="demo()">FAQ &nbsp;&nbsp;&nbsp; <i class="fa-solid fa-clipboard-question"></i></p>
    <p (click)="open()">Contact us &nbsp;&nbsp;&nbsp; <i class="fa-solid fa-clipboard-question"></i></p> -->
  <div class="header-container">
    <nb-actions size="small">
  <!-- 
      <nb-action class="control-item">
        <nb-search type="rotate-layout"></nb-search>
      </nb-action> -->
      <!-- <nb-action class="control-item" icon="email-outline"></nb-action>
      <nb-action class="control-item" icon="bell-outline"></nb-action> -->
      <nb-action class="user-action"  *nbIsGranted="['view', 'current-user']">
        <nb-user [nbContextMenu]="userMenu"
                 [onlyPicture]="userPictureOnly"
                 [name]="user?.firstName"
                 [picture]="user?.picture | ngxAuthToken | async">
        </nb-user>
      </nb-action>
    </nb-actions>
  </div>
  